// import {eventBus} from "@maya/helper/utilities";

import {eventBus} from "../../../utilities/src";

declare global {
  interface Window {
    Android: {
      notify?: (type: string, message: string) => void;
      download?: (
        fileName: string,
        base64: string,
        contentLength: number | null,
        fileType: string,
      ) => void;
    };
  }
}

export enum AndroidAction {
  AUTH_TOKEN_REQUEST = "AUTH_TOKEN_REQUEST",
  REQUEST_LOCATION = "REQUEST_LOCATION",
  LOCATION_UPDATE_TIME = "LOCATION_UPDATE_TIME",
}

export const isAndroid = () => {
  return !!window.Android;
};

export const clearWebStack = () => {
  window.Android.notify?.("CLEAR_WEBVIEW_STACK", JSON.stringify({}));
};

export const hasNotify = () => {
  return !!window?.Android?.notify;
};

export const notifyAndroid = (type: string, payload: {[key: string]: any}) => {
  window?.Android?.notify?.(type, JSON.stringify(payload));
};

export const downloadFileAndroid = (
  fileName: string,
  base64: string,
  contentLength: number | null,
  fileType: string,
) => {
  if (!window.Android?.download) return;
  window.Android?.download(fileName, base64, contentLength, fileType);
};

type ToolBarConfig = {
  visibility: boolean;
  title: string;
};

export const setToolBarConfig = (config: ToolBarConfig) => {
  notifyAndroid("TOOL_BAR_CONFIG", config);
};

export const exitWebview = () => {
  (window as any).Android.exit();
};

(window as any).notifyToWeb = ({
  type,
  value,
}: {
  type: string;
  value: string;
}) => {
  if (type === AndroidAction.AUTH_TOKEN_REQUEST) {
    eventBus.dispatch(AndroidAction.AUTH_TOKEN_REQUEST, value);
  }
  if (type === AndroidAction.REQUEST_LOCATION) {
    eventBus.dispatch(AndroidAction.REQUEST_LOCATION, value);
  }
};

export const getAndroidToken = async (): Promise<string> => {
  return new Promise((res, rej) => {
    eventBus.on(AndroidAction.AUTH_TOKEN_REQUEST, (rawPayload: any) => {
      const payload = JSON.parse(String(rawPayload));
      eventBus.remove(AndroidAction.AUTH_TOKEN_REQUEST);
      if (payload.data.token) {
        res(payload.data.token);
      } else {
        rej();
      }
    });
    notifyAndroid(AndroidAction.AUTH_TOKEN_REQUEST, {});
  });
};

export const getAndroidLocation = async (): Promise<{
  latitude: number;
  longitude: number;
}> => {
  return new Promise((res, rej) => {
    eventBus.on(AndroidAction.REQUEST_LOCATION, (rawPayload: any) => {
      const payload = JSON.parse(String(rawPayload));
      eventBus.remove(AndroidAction.REQUEST_LOCATION);
      if (payload) {
        res(payload);
      } else {
        rej();
      }
    });
    notifyAndroid(AndroidAction.REQUEST_LOCATION, {});
  });
};
